import http from '@/support/plugin/axios'

export const 

//Pega todas as informações da tela
getContactInfoById = ( companyId ) => http.get(`companies/${companyId}/branches`)